module.exports = __webpack_public_path__ + "img/doodle-7898618_1280.b6f2fa64.jpg";